import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATES_APPROVED_ROUTE_NAME } from '@modules/affiliates-approved/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS,
} from './constants';
import { ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME } from './submodules/main/constants';
import { AffiliatesApprovedTrackersSettingsMainModule } from './submodules/main/TrackersSettingsMainModule';
import { AffiliatesApprovedTrackersSettingsSubaffiliateConditionModule } from './submodules/subaffiliate-condition/TrackersSettingsSubaffiliateConditionModule';
import { AffiliatesApprovedTrackerGroupsModule } from './submodules/tracker-groups/AffiliateTrackerGroupsModule';
import { AffiliatesApprovedTrackersSettingsListModule } from './submodules/trackers-list/TrackersSettingsListModule';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedTrackersSettingsModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedTrackersSettingsMainModule(),
    new AffiliatesApprovedTrackersSettingsListModule(),
    new AffiliatesApprovedTrackersSettingsSubaffiliateConditionModule(),
    new AffiliatesApprovedTrackerGroupsModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATES_APPROVED_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME,
      path: 'settings/:id',
      component: () => import('./pages/AffiliateTrackersSettingsPage/AffiliateTrackersSettingsPage.vue'),
      redirect: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS, getTranslationKeys);
  }
}
